import React from 'react';
import AdUnit, { useAds } from './AdUnit';

const HeaderAdBanner = ({ className = '' }) => {
  const ads = useAds('header', 3);
  if (!ads.length) return null;

  // Rotate by day-of-year among active header creatives
  const day = Math.floor(Date.now() / 86400000);
  const ad = ads[day % ads.length];

  return (
    <div className={`ad-header-slot ${className}`.trim()}>
      <div className="ad-header-slot__inner">
        <AdUnit ad={ad} variant="header" />
      </div>
    </div>
  );
};

export default HeaderAdBanner;
